import {omit} from 'lodash';
import React, {Component} from 'react';
import styled from 'styled-components';

import {BoxedInputChildProps} from '../../../../libs/shared/ui/src/components/boxedInputs/boxedInputConstants';
import {MarkdownEditor, MarkdownEditorProps} from '../editor/markdown/markdownEditor';

/*
 * Props.
 */

export interface BoxedMarkdownEditorProps extends MarkdownEditorProps, BoxedInputChildProps {
  className?: string;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  flex: auto;
  overflow-x: hidden;
`;

const StyledEditor = styled(MarkdownEditor)`
  padding: 6px 8px 4px 8px;
`;

/*
 * Component.
 */

export class BoxedMarkdownEditor extends Component<BoxedMarkdownEditorProps> {
  render() {
    return (
      <StyledWrapperDiv className={this.props.className}>
        <StyledEditor {...omit(this.props, 'className')} />
      </StyledWrapperDiv>
    );
  }
}
